import * as ko from 'knockout';
import {Notifier} from "Core/Common/Notifier";

import UICheatSheetTemplate from 'Core/Components/UICheatSheet/Templates/Template.html';
ko.templates['Core/Components/UICheatSheet/Templates/Template'] = UICheatSheetTemplate;

interface ButtonItem {
    classes: string;
    html: string;
}

export class UICheatSheet {
    private _buttonVariants: KnockoutObservableArray<string>;

    private _buttonColorsRed: KnockoutObservableArray<string>;
    private _generatedButtonsRed: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsOrange: KnockoutObservableArray<string>;
    private _generatedButtonsOrange: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsYellow: KnockoutObservableArray<string>;
    private _generatedButtonsYellow: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsGreen: KnockoutObservableArray<string>;
    private _generatedButtonsGreen: KnockoutComputed<ButtonItem[]>;

    private _buttonColorsBlue: KnockoutObservableArray<string>;
    private _generatedButtonsBlue: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsViolet: KnockoutObservableArray<string>;
    private _generatedButtonsViolet: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsGray: KnockoutObservableArray<string>;
    private _generatedButtonsGray: KnockoutComputed<ButtonItem[]>;

    private _buttonColorsZinc: KnockoutObservableArray<string>;
    private _generatedButtonsZinc: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsNeutral: KnockoutObservableArray<string>;
    private _generatedButtonsNeutral: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsBlack: KnockoutObservableArray<string>;
    private _generatedButtonsBlack: KnockoutComputed<ButtonItem[]>;
    
    private _buttonColorsWhite: KnockoutObservableArray<string>;
    private _generatedButtonsWhite: KnockoutComputed<ButtonItem[]>;
    
    constructor() {
        this.Init();
    }
    
    Init(){
        this._buttonVariants = ko.observableArray<string>(["sps-btn-outline", "", "sps-btn-ghost"]);

        // Buttons Red
        this._buttonColorsRed = ko.observableArray<string>(["sps-btn-red-600", "sps-btn-red-700", "sps-btn-red-800", "sps-btn-red-950",]);
        this._generatedButtonsRed = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsRed()));
        // Buttons Orange
        this._buttonColorsOrange = ko.observableArray<string>(["sps-btn-orange-100", "sps-btn-orange-200", "sps-btn-orange-400", "sps-btn-orange-950",]);
        this._generatedButtonsOrange = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsOrange()));
        // Buttons Yellow
        this._buttonColorsYellow = ko.observableArray<string>(["sps-btn-yellow-400", "sps-btn-yellow-500", "sps-btn-yellow-600", "sps-btn-yellow-700","sps-btn-yellow-800","sps-btn-yellow-950",]);
        this._generatedButtonsYellow = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsYellow()));
        // Buttons Green
        this._buttonColorsGreen = ko.observableArray<string>(["sps-btn-green-100", "sps-btn-green-200", "sps-btn-green-500", "sps-btn-green-600","sps-btn-green-700","sps-btn-green-800","sps-btn-green-950",]);
        this._generatedButtonsGreen = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsGreen()));
        // Buttons Blue
        this._buttonColorsBlue = ko.observableArray<string>(["sps-btn-blue-50", "sps-btn-blue-100", "sps-btn-blue-200", "sps-btn-blue-300","sps-btn-blue-500","sps-btn-blue-600","sps-btn-blue-700","sps-btn-blue-800","sps-btn-blue-950",]);
        this._generatedButtonsBlue = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsBlue()));
        // Buttons Violet
        this._buttonColorsViolet = ko.observableArray<string>(["sps-btn-violet-50", "sps-btn-violet-100", "sps-btn-violet-200", "sps-btn-violet-500","sps-btn-violet-600","sps-btn-violet-700","sps-btn-violet-800","sps-btn-violet-950",]);
        this._generatedButtonsViolet = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsViolet()));
        // Buttons Gray
        this._buttonColorsGray = ko.observableArray<string>(["sps-btn-gray-50", "sps-btn-gray-100", "sps-btn-gray-200", "sps-btn-gray-300","sps-btn-gray-400","sps-btn-gray-500","sps-btn-gray-600","sps-btn-gray-700","sps-btn-gray-800","sps-btn-gray-900",]);
        this._generatedButtonsGray = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsGray()));
        // Buttons Zinc
        this._buttonColorsZinc = ko.observableArray<string>(["sps-btn-zinc-300", "sps-btn-zinc-600",]);
        this._generatedButtonsZinc = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsZinc()));
        // Buttons Neutral
        this._buttonColorsNeutral = ko.observableArray<string>(["sps-btn-neutral-200", "sps-btn-neutral-700",]);
        this._generatedButtonsNeutral = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsNeutral()));
        // Buttons Black
        this._buttonColorsBlack = ko.observableArray<string>(["sps-btn-black"]);
        this._generatedButtonsBlack = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsBlack()));
        // Buttons White
        this._buttonColorsWhite = ko.observableArray<string>(["sps-btn-white"]);
        this._generatedButtonsWhite = ko.pureComputed<ButtonItem[]>(() => this.GenerateButtons(this._buttonColorsWhite()));
    }


    private GenerateButtons(colors: string[]): ButtonItem[] {
        const result: ButtonItem[] = [];
        colors.forEach(colorClass => {
            this._buttonVariants().forEach(variant => {
                const classes = [variant, colorClass].filter(Boolean).join(" ");
                const html = `<i class="fa-brands fa-shopify"></i> ${[ ".sps-btn", variant ? "." + variant : "", "." + colorClass ].filter(Boolean).join(" ")}`;
                result.push({ classes, html });
            });
        });
        return result;
    }

    GetTemplateName() {
        return 'Core/Components/UICheatSheet/Templates/Template';
    }

    GetTemplate() {
        return UICheatSheetTemplate;
    }

    AfterRender() {

        // Fallback for browsers without navigator.clipboard
        function fallbackCopyTextToClipboard(text: string): Promise<void> {
            return new Promise<void>((resolve, reject) => {
                const textArea = document.createElement("textarea");
                textArea.value = text;

                // Hide element from the page layout
                textArea.style.position = "fixed";
                textArea.style.left = "-9999px";
                textArea.style.top = "0";
                textArea.setAttribute('readonly', '');

                document.body.appendChild(textArea);

                // For iOS compatibility
                textArea.select();
                textArea.setSelectionRange(0, textArea.value.length);

                try {
                    const successful = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    if (successful) resolve(); // TS OK now because Promise<void>
                    else reject(new Error('execCommand returned false'));
                } catch (err) {
                    document.body.removeChild(textArea);
                    reject(err);
                }
            });
        }

        // Universal copy function
        function copyTextToClipboard(text: string): Promise<void> {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                return navigator.clipboard.writeText(text);
            } else {
                return fallbackCopyTextToClipboard(text);
            }
        }

        // jQuery click handler
        $("#buttons-list, #text-list").on("click", "a, button", function () {
            const classes = $(this).attr("class") || "";
            if (!classes) return;

            copyTextToClipboard(classes)
                .then(() => {
                    new Notifier().Success("Copied: " + classes);
                })
                .catch(err => {
                    new Notifier().Failed("Copy error", err);
                });
        });
    }
}